import { useTranslation } from "react-i18next";
import { ConfigForm } from "./ConfigForm";

const Configs = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className="mb-6 p-6 rounded-xl bg-white shadow-sm">
        <h1 className="text-2xl font-bold">{t("configs.title")}</h1>
        <p className="text-gray-600 mt-2">{t("configs.description")}</p>
      </div>

      <div className="bg-white rounded-xl p-6">
        <ConfigForm />
      </div>
    </>
  );
};

export default Configs; 